import styled from "styled-components";

const PageTitle = styled.h1`
  font-weight: 300;
  text-align: center;
  margin-top: 2rem;
`;

export { PageTitle };
